import { render } from "./ResolveConflict.vue?vue&type=template&id=556be730"
import script from "./ResolveConflict.vue?vue&type=script&lang=js"
export * from "./ResolveConflict.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__